<template>
  <v-container fluid tag="section">
    <div  v-if="item.length === 0">
      <img :src="require('@/assets/images/empty.png')" height="300" :width="$isMobile ? '100%' : 300"/>
    </div>
    <div class="pd-c-12" v-for="(itm, idx) in item" :key="idx">
      <v-row>
        <v-col cols='12' :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
          操作时间：<span class="font-weight-black">{{itm === undefined  ? '' :  itm.createTime | formatDate }}</span>
        </v-col>
        <v-col cols='12' :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
          操作人员：<span class="font-weight-black">{{itm.createUser === undefined  ? '' :  itm.createUser.name }}</span>
        </v-col>
        <v-col cols='12' :md='mini ? 6 : 4' :class="$isMobile ? 'size-13' : ''">
          专利状态：<span class="font-weight-black">{{itm === undefined  ? '' :  itm.statusVal }}</span>
        </v-col>
        <v-col cols='12' md='12' :class="$isMobile ? 'size-13' : ''">
          备注信息：<span class="font-weight-black">{{itm === undefined  ? '' :  itm.remark }}</span>
        </v-col>
      </v-row>
      <v-divider class="mt-5" v-if="idx + 1 < item.length"></v-divider>
    </div>
  </v-container>
</template>

<script>
  export default {
    name: 'RecordDetail',
    props: {
      item: {
        type: Array,
        default: () => ([])
      },
      lazy: {
        type: Boolean,
        default: false
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {}
    },
    methods: {
    }
  }
</script>

<style lang="sass">
  #system-user-detail-page
    .custom-font
      color: white !important
</style>
